import type { Services } from "@/lib/services"
import { emptyServicesCollection } from "@/lib/services/constants"

export const buildServicesCollection = <Element extends object>(
  entries?: Partial<Services.Collection<Element>>
) => {
  return {
    ...emptyServicesCollection,
    ...entries,
  } as Services.Collection<Element>
}
